module.exports = __webpack_public_path__ + "img/loyalty-program.907f6a33.svg";